import {getTestProps} from '@benchling/js-test-utils';
import {useWindowEvent} from '@mantine/hooks';
import React, {useState} from 'react';

import * as analytics from 'analytics/Analytics';
import KeyboardShortcutsModal from 'components/KeyboardShortcutsModal';
import * as keyboard from 'util/Keyboard';

export default function KeyboardShortcutsStatusBarButton(): JSX.Element {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useWindowEvent('keydown', (e) => {
    if (keyboard.isCtrlQuestionMark(e)) {
      e.preventDefault();
      setIsModalOpen((prev) => {
        if (prev) {
          return false;
        }
        analytics.track('statusbar', 'keyboard_shortcuts_opened');
        return true;
      });
    }
  });

  return (
    <>
      <span
        className="statusbar-label btn btn-af-default keyboard-shortcuts"
        onClick={() => {
          setIsModalOpen(true);
          analytics.track('statusbar', 'keyboard_shortcuts_opened');
        }}
        {...getTestProps({component: 'StatusBar', element: 'keyboardShortcutsButton'})}
      >
        Keyboard Shortcuts
      </span>
      <KeyboardShortcutsModal
        opened={isModalOpen}
        onRequestClose={() => {
          setIsModalOpen(false);
        }}
      />
    </>
  );
}
